import { render } from "./OptionalAgree.vue?vue&type=template&id=23a22482&scoped=true&ts=true"
import script from "./OptionalAgree.vue?vue&type=script&lang=ts"
export * from "./OptionalAgree.vue?vue&type=script&lang=ts"

import "./OptionalAgree.vue?vue&type=style&index=0&id=23a22482&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/hems-frontend-vue_eu_v1.33.0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23a22482"]])

export default __exports__